import { Box } from '@mui/material'
import { EmptyContent } from 'components/common/EmptyContent'
import { FC } from 'react'
import { GRAY_800 } from 'constants/styling/theme'
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined'
import { MUIButton } from 'components/common/MUIButton'
import { Path } from 'constants/router'
import Stack from '@mui/material/Stack'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'

/**
 * @component
 * PropertiesDashboardEmptyContent component displays a placeholder screen when there are no properties to show.
 *
 * @example
 * <PropertiesDashboardEmptyContent />
 */
export const PropertiesDashboardEmptyContent: FC = () => {
  const { t } = useTranslation(['properties_dashboard'], { keyPrefix: 'properties_empty_content' })
  const navigate = useNavigate()

  return (
    <Box maxWidth="60rem" width="40rem" margin="auto" marginTop="8rem">
      <EmptyContent
        title={t('title')}
        description={t('description')}
        icon={<HomeWorkOutlinedIcon sx={{ color: GRAY_800, fontSize: '2.8rem' }} />}
        button={
          <Stack flexDirection="row" gap=".8rem" alignItems="center" justifyContent="center" width="100%" marginTop="2.4rem">

            <MUIButton
              type="secondaryBorder"
              onClick={() => navigate(Path.PURCHASE_FLOW)}
            >
              {t('place_an_order')}
            </MUIButton>

            <MUIButton
              onClick={() => navigate(Path.NEW_PROPERTIES)}
            >
              {t('create_a_property')}
            </MUIButton>

          </Stack>
        }
      />
    </Box>
  )
}
